import { render, staticRenderFns } from "./VideoMedia.vue?vue&type=template&id=62708dc6&scoped=true&"
import script from "./VideoMedia.vue?vue&type=script&lang=js&"
export * from "./VideoMedia.vue?vue&type=script&lang=js&"
import style0 from "./VideoMedia.vue?vue&type=style&index=0&id=62708dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62708dc6",
  null
  
)

export default component.exports